// Supported UI languages for the WithMe platform.
// Keep this list in sync with backend validation sets.
export const SUPPORTED_LANGUAGES = [
   { code: 'en',    label: 'English (UK)', nativeLabel: 'English (UK)', flag: '🇬🇧' },
   { code: 'en-US', label: 'English (US)', nativeLabel: 'English (US)', flag: '🇺🇸' },
   { code: 'fr', label: 'French',     nativeLabel: 'Français',   flag: '🇫🇷' },
   { code: 'es', label: 'Spanish',    nativeLabel: 'Español',    flag: '🇪🇸' },
   { code: 'de', label: 'German',     nativeLabel: 'Deutsch',    flag: '🇩🇪' },
   { code: 'pt', label: 'Portuguese', nativeLabel: 'Português',  flag: '🇵🇹' },
   { code: 'it', label: 'Italian',    nativeLabel: 'Italiano',   flag: '🇮🇹' },
   { code: 'no', label: 'Norwegian',  nativeLabel: 'Norsk',      flag: '🇳🇴' },
   { code: 'pl', label: 'Polish',     nativeLabel: 'Polski',     flag: '🇵🇱' },
   { code: 'nl', label: 'Dutch',      nativeLabel: 'Nederlands', flag: '🇳🇱' },
];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);

export const DEFAULT_LANGUAGE = 'en';

export const getLanguageByCode = (code) =>
   SUPPORTED_LANGUAGES.find((l) => l.code === code) || null;
